module.exports = __webpack_public_path__ + "static/img/one.b38ca1c0.png";